import 'bootstrap/dist/js/bootstrap';
import 'simplelightbox/dist/simple-lightbox.jquery';

$( document ).ready(function() {
  // Lightbox
  try { // this throws an error, when there is no lightbox element
    $('.lightbox a').simpleLightbox({
      animationSpeed: 200,
      animationSlide: false,
      captionSelector: 'self'
    });
  } catch (err) {
    //console.log(err);
  }

  // textboxtoggle
  $('.textboxtoggle__button > *').click(function () {
    $(this).parent().toggleClass('expanded');
    var target = $(this).data('target');
    if (target) {
      $('#' + target).slideToggle(300);
      console.log('#' + target);
    } else {
      console.log('parent');
      $(this).parent().parent().children('.textboxtoggle__content').slideToggle(300);
    }
    if ($(this).parent().hasClass('expanded')) {
      $(this).html($(this).data('textexpanded'));
    } else {
      $(this).html($(this).data('textcollapsed'));
    }
  });

  // additional span element for form fields for nice animation
  $(`.formfield__input input[type="text"],
    .formfield__input input[type="email"],
    .formfield__input input[type="tel"],
    .formfield__input input[type="number"],
    .formfield__input textarea,
    .formfield__input select`).after('<span></span>');
  
  // event listener for contact forms: hide form when sent successfully
  document.addEventListener( 'wpcf7mailsent', function( event ) {
    // hide form
    $('.wpcf7-form.sent .formwrapper').slideUp(300);
  }, false );

  // click hidden button to open modal
  $('.comby-linkbutton--kostenlos-schnuppern').click(function (e) {
    e.preventDefault();
    $('#schnupperstunde-modal-button').click();
  });

  $('.combycourselist__heading').on('click', function () {
    $(this).parent().parent().parent().find('.combycourselist__wrapper').slideToggle(200);
  });
});
